<template>
    <div class="spark-content-webinar-card">
        <div class="external-card-title">{{ props.isUpcoming ? 'Sign up now' : 'Watch webinar' }}</div>
        <div class="external-card-description">
            {{ props.isUpcoming ? 'Sign up for the webinar in a new tab.' : 'Open this webinar in a new tab.' }}
        </div>
        <primevue-button class="plain-btn" @click="emit('open')">
            {{ props.isUpcoming ? 'Sign up' : 'Open webinar' }}
            <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" />
        </primevue-button>
    </div>
</template>

<script setup lang="ts">
import PrimevueButton from 'primevue/button';

const props = defineProps<{
    isUpcoming?: boolean;
}>();

const emit = defineEmits<{
    open: [];
}>();
</script>

<style scoped lang="scss">
.spark-content-webinar-card {
    display: flex;
    flex-direction: column;
    gap: var(--defaultSpacing);
    align-items: flex-start;
    padding: var(--largeSpacing);
    background: var(--neutral100);
    border: 1px solid var(--neutral300);
    border-radius: var(--borderRadiusOuter);
}

.external-card-title {
    font-weight: var(--boldFontWeight);
    font-size: var(--largeFontSize);
}

.external-card-description {
    color: var(--neutral700);
}
</style>
